import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  VStack,
} from "@chakra-ui/react";

export const ReAuthEmailPasswordModal = (props) => {
  const { isOpen, setIsOpen, authenticate, isAuthenticating } = props;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.newEmail.value;
    const password = e.target.password.value;

    await authenticate(email, password);
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit}>
          <ModalHeader>{"Authenticate"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Stack spacing={{ base: 2, md: 5 }}>
              <FormControl>
                <FormLabel htmlFor="email">Email</FormLabel>
                <Input id="newEmail" type="email" />
              </FormControl>
              <FormControl isRequired>
                <FormLabel htmlFor="password">Password</FormLabel>
                <Input id="password" type="password" />
              </FormControl>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <VStack>
              <Box>
                <Button
                  mr={3}
                  onClick={() => {
                    setIsOpen(false);
                  }}
                  variant="outline"
                >
                  Close
                </Button>
                <Button
                  variant="solid"
                  isLoading={isAuthenticating}
                  type="submit"
                >
                  Authenticate
                </Button>
              </Box>
              <div
                id="recaptcha-container-id"
                style={{ display: "flex", justifyContent: "center" }}
              ></div>
            </VStack>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};
